import { useQuery } from '@tanstack/react-query';
import {
    RECEIPT_READ_DENIED_MESSAGE,
    vacationReceiptService,
} from '../../services/vacationReceiptService';
import type { VacationReceipt } from '../../models/vacationReceipt.types';

export const VACATION_RECEIPTS_QUERY_KEY = 'vacationReceipts';

export function useVacationReceiptsQuery(collaboratorId?: string, ownerEmail?: string) {
    const { data, isLoading, error } = useQuery<VacationReceipt[]>({
        queryKey: [VACATION_RECEIPTS_QUERY_KEY, collaboratorId, ownerEmail ?? null],
        queryFn: () => vacationReceiptService.listByCollaborator(collaboratorId as string, ownerEmail),
        enabled: Boolean(collaboratorId),
        staleTime: 5 * 60 * 1000,
    });

    return {
        receipts: data ?? [],
        isLoading,
        error: describeReadError(error),
    };
}

function describeReadError(error: unknown): string | null {
    if (!error) return null;
    if (error instanceof Error && error.message.includes('permission-denied')) {
        return RECEIPT_READ_DENIED_MESSAGE;
    }
    return error instanceof Error ? error.message : String(error);
}
